<template>
<div class="head">
    <div class="header-flex">
        <p class="text-title"> {{headerText}} <em>{{headerTextEmpahasis}}</em></p>
        <p>{{subText}}</p>
        <div class="input-container" v-if="isTextinput">
            <b-input-group>
                <template #prepend>
                    <font-awesome-icon :icon="['fas', 'search']" />
                </template>
                <b-form-input id="searchInput" v-model="searchText" placeholder="What will you like to know?"></b-form-input>
                <template #append>
                    <button @click="handleClick" class="btn-yellow" type="submit">
                        <b-icon id="icon-s" font-scale="0.8" icon="search"></b-icon> Search
                    </button>
                </template>
            </b-input-group>
        </div>
    </div>
    <p class="backdrop-text">
        {{fadedText}}
    </p>

</div>
</template>

<script>
export default {
    name: 'black-header-right',
    props: ["headerText", "headerTextEmpahasis", "subText", "fadedText", "isTextinput"],
    data: function () {
        return {
            searchText: ''
        }
    },
    mounted() {
        var input = document.getElementById('searchInput');
        var icon = document.getElementById('icon-s');
        var btn = document.getElementsByClassName('btn-yellow')[0];

        if (input) {
            input.addEventListener('focus', function () {
                btn.style.width = '110px'
                icon.style.display = 'inline-block';

            });
            input.addEventListener('focusout', function () {
                icon.style.display = 'none';
                btn.style.width = '100px'
            });
        }

    },
    methods: {
        handleClick() {
            this.$emit('handleSearch', this.searchText)
        }
    }

}
</script>

<style lang="scss" scoped>
.head {
    background-color: #000;
    height: 65vh;
    margin-top: -104px;
    padding-top: 209px;
    padding-left: 70px;
    color: #fff;
}

.backdrop-text {
    font-size: 200px;
    padding-top: 30px;
    position: absolute;
    top: 15%;
    right: 0;
    overflow: hidden;
    font-weight: bold;
    background: -webkit-linear-gradient(#333, #060606);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.text-title {
    font-weight: bold;
    font-size: 34px !important;
    line-height: 64px;
    letter-spacing: -0.25px;
    text-transform: uppercase;
    color: #FFFFFF;

}

.header-flex {
    position: relative;
    z-index: 99
}

.header-flex p {
    font-size: 24px;
    margin-bottom: 0 !important;
}

.text-title em {
    color: #F7B131;

}

.input-group {
    width: 100% !important;
    margin: 0 auto !important;

}

.input-group-prepend {
    padding-top: 8px !important;
    margin-right: 10px !important;
}

.input-container {
    margin-top: 35px;
    border: 1px solid #fff;
    padding: 19px;
    width: 40%;
    border-radius: 5px;
}

.btn-yellow {
    width: 100px;
    height: 35px;
    left: calc(50% - 74px/2 + 166px);
    top: calc(50% - 35px/2);
    background: #F7B131;
    border-radius: 4px;
    border: none;
    color: #fff;
    z-index: 99;
    transition: width 1s;
}

.form-control {
    background-color: transparent !important;
    border: none !important;
    color: #fff !important
}

.form-control:focus {
    box-shadow: none !important;
    color: #fff !important;
}

.b-icon.bi {
    display: none;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: #fff !important;
}
</style>
